import { z } from 'zod';

export enum OfflineSubmissionType {
  SW_NEW_APPROVAL = 'Special Waste Profile (New Approval)',
  EX_NEW_APPROVAL = 'Express Waste Profile (New Approval)',
  SW_RECERTIFY = 'Recertification - Special Waste',
  EX_RECERTIFY = 'Recertification - Express',
  SW_RECERTIFY_W_CHANGE = 'Recertification with Change - Special Waste',
  EX_RECERTIFY_W_CHANGE = 'Recertification with Change - Express',
  SW_CHANGE = 'Change - Special Waste',
  EX_CHANGE = 'Change - Express',
}

export interface OfflineSubmissionTypeFormOption {
  type: OfflineSubmissionType;
  isApproved: boolean;
}

export const offlineSubmissionTypeFormOptions = [
  { type: OfflineSubmissionType.SW_NEW_APPROVAL, isApproved: false },
  { type: OfflineSubmissionType.EX_NEW_APPROVAL, isApproved: false },
  { type: OfflineSubmissionType.SW_RECERTIFY, isApproved: true },
  { type: OfflineSubmissionType.EX_RECERTIFY, isApproved: true },
  { type: OfflineSubmissionType.SW_RECERTIFY_W_CHANGE, isApproved: true },
  { type: OfflineSubmissionType.EX_RECERTIFY_W_CHANGE, isApproved: true },
  { type: OfflineSubmissionType.SW_CHANGE, isApproved: true },
  { type: OfflineSubmissionType.EX_CHANGE, isApproved: true },
] as const;

export const offlineSubmissionTypeOptions = [
  OfflineSubmissionType.SW_NEW_APPROVAL,
  OfflineSubmissionType.EX_NEW_APPROVAL,
  OfflineSubmissionType.SW_RECERTIFY,
  OfflineSubmissionType.EX_RECERTIFY,
  OfflineSubmissionType.SW_RECERTIFY_W_CHANGE,
  OfflineSubmissionType.EX_RECERTIFY_W_CHANGE,
  OfflineSubmissionType.SW_CHANGE,
  OfflineSubmissionType.EX_CHANGE,
] as const;

export const OfflineSubmissionTypeSchema = z.enum(offlineSubmissionTypeOptions);

export type OfflineSubmissionTypeOptions = z.infer<
  typeof OfflineSubmissionTypeSchema
>;
